import React from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import { blogPosts } from "@/data/blogData";

const BlogPostPage = () => {
  const { slug } = useParams<{ slug: string }>();

  // Clean slug in case route came in with .html extension
  const cleanSlug = slug ? slug.replace(/\.html$/, "") : "";
  const post = blogPosts[cleanSlug];

  if (!post) {
    return <Navigate to="/blog" replace />;
  }

  return (
    <div className="w-full bg-[#0f0f0f] text-[#f2f2f2] min-h-screen">
      <div className="max-w-[800px] mx-auto px-5 py-[60px] md:py-[100px]">
        {/* Back link */}
        <div className="mb-8">
          <Link
            to="/blog"
            className="text-sm text-[#666666] hover:text-white transition-colors font-mono inline-flex items-center gap-1"
          >
            ← Builder Notes
          </Link>
        </div>

        {/* Article Meta */}
        <div className="flex flex-wrap items-center gap-3 mb-4">
          {post.tags.map((tag) => (
            <span
              key={tag}
              className="bg-[#1e1e1e] text-[#888888] text-[11px] px-[10px] py-[4px] rounded-[4px] font-mono"
            >
              {tag}
            </span>
          ))}
          <span className="text-xs text-[#555555] font-mono">•</span>
          <span className="text-xs text-[#555555] font-mono">{post.date}</span>
        </div>

        {/* Article Title */}
        <h1
          className="text-[32px] sm:text-[44px] font-bold text-[#f2f2f2] leading-[1.2] mb-8"
          style={{ fontFamily: "'DM Sans', sans-serif" }}
        >
          {post.title}
        </h1>

        <div className="w-full h-px bg-[#1a1a1a] mb-10" />

        {/* Article Content */}
        <div
          className="prose prose-invert max-w-none text-[16px] text-[#cccccc] leading-[1.7]"
          dangerouslySetInnerHTML={{ __html: post.contentHtml }}
        />

        {/* Read Next Section */}
        {post.nextSlug && post.nextTitle && (
          <div className="mt-16 pt-10 border-t border-[#1a1a1a]">
            <div className="text-[11px] uppercase tracking-[0.12em] text-[#555555] font-mono mb-2">
              READ NEXT
            </div>
            <Link
              to={`/blog/${post.nextSlug}`}
              className="text-[20px] font-bold text-[#f2f2f2] hover:text-white transition-colors block leading-snug"
              style={{ fontFamily: "'DM Sans', sans-serif" }}
            >
              {post.nextTitle} →
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default BlogPostPage;
